import { useLocation } from 'react-router-dom'
import { Link } from 'react-router-dom'
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbPage,
} from '../../ui/breadCrumbs'

type RoutesMap = {
  [key: string]: string
}

const routeNameMap: RoutesMap = {
  '/': 'Home',
  '/home': 'Home',
  '/support/casemanagement': 'Case Management',
  '/support': 'Support',
  '/support/casemanagement/create': 'Create Ticket',
  '/users': 'Users',
  '/sitedetails': 'Site Details',
  '/sitepage': 'Site Details',
  '/siteusers': 'Site Users',
  '/technologyandnetworks/sitelist': 'Site List',
  '/sdwan': 'SD-WAN',
  '/servicebilling': 'Service Billing',
  '/security': 'Security',
  '/switching': 'Switching',
  '/wireless': 'Wireless',
  '/voice': 'Voice',
  '/monitor': 'Monitor',
  '/reports': 'Reports',
  '/groups': 'Groups',
  '/roles': 'Roles',
  '/helpandfeedback': 'Help and Feedback',
  '/technologyandnetworks/networkperformance': 'Network Performance',
  '/settings': 'Settings',
  '/technologyandnetworks/sitepage': 'Overview',
  '/technologyandnetworks': 'Technology and Networks',
  '/billingandusage/servicebilling': 'Service Billing',
  '/billingandusage/details': 'Details',
  '/billingandusage/paymentmethods': 'Payment Methods',
  '/billingandusage': 'Billing & Usage',
  '/technologyandnetworks/serviceinventory': 'Service Inventory',
  '/technologyandnetworks/sitepage/alerts': 'Recent Alerts',
  '/analyticsandreports': 'Analytics & Reports',
  '/analyticsandreports/reports': 'Reports',
  '/analyticsandreports/reports/1264': 'Account Billing Summary',
  '/analyticsandreports/reports/1122': 'Line Billing Summary',
  '/analyticsandreports/reports/1059': 'Line Inventory',
  '/analyticsandreports/reports/scheduledreports': 'Scheduled Reports',
  '/userandgroups': 'Users & Groups',
  '/userandgroups/users': 'Users',
  '/orders': 'Orders',
  '/technologyandnetworks/activeservices': 'Active Services',
  '/technologyandnetworks/activeservices/:nodeIpAddress': 'Node Details',
}

const meaningfulRoutes = new Set([
  '/analyticsandreports/reports/1264',
  '/analyticsandreports/reports/1122',
  '/analyticsandreports/reports/1059',
])

export default function BreadCrumbs() {
  const location = useLocation()
  const { pathname } = location
  const pathnames = pathname === '/' ? [''] : pathname.split('/').filter(x => x)

  const filteredPathnames: string[] = []
  let stopProcessing = false

  pathnames.reduce((acc, name) => {
    if (stopProcessing) return acc
    const currentPath = name ? `${acc}/${name}` : '/'

    filteredPathnames.push(name)

    if (meaningfulRoutes.has(currentPath)) {
      stopProcessing = true
    }

    return currentPath
  }, '')

  const stateContactName =
    (location.state as { contact?: { fullName?: string }; fullName?: string })
      ?.contact?.fullName ||
    (location.state as { contact?: { fullName?: string }; fullName?: string })
      ?.fullName

  return (
    <div>
      <Breadcrumb className=' py-padding-xs text-primary-foreground'>
        {filteredPathnames.map((name, index) => {
          const routeTo = `/${filteredPathnames
            .slice(0, index + 1)
            .filter(Boolean)
            .join('/')}`
          const isLast = index === filteredPathnames.length - 1
          const isFirst = index === 0
          const rawDisplayName =
            routeNameMap[routeTo] ||
            name.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase())

          const displayName =
            isLast && stateContactName ? stateContactName : rawDisplayName

          return (
            <BreadcrumbItem className='text-primary-foreground' key={routeTo}>
              {isFirst ? (
                <>
                  <span className='pr-padding-xl'>{displayName}</span> |
                </>
              ) : isLast ? (
                <BreadcrumbPage className='font-semibold ml-1'>
                  <span className='px-padding-xl'>{displayName}</span>
                </BreadcrumbPage>
              ) : (
                <Link to={routeTo} className='ml-1'>
                  <span className='px-padding-xl'>{displayName}</span> |
                </Link>
              )}
            </BreadcrumbItem>
          )
        })}
      </Breadcrumb>
    </div>
  )
}
